import { DataTable } from "@/components/data-table";
import { ListPage } from "@/components/list-page";
import { useOpenModal } from "@/components/modal";
import useHasPermisos from "@/features/auth/hooks/useHasPermisos";
import { Permiso } from "@/shared/types/permiso";
import { Button } from "@mui/material";

export default function CajaClosed() {
    const hasOpenPermiso = useHasPermisos(Permiso.AperturaCierreCajas);
    const hasViewHistorialPermiso = useHasPermisos(Permiso.HistorialAperturaCajaActual);
    const openModal = useOpenModal();

    return <ListPage>
        <ListPage.Header>
            <ListPage.Header.Actions title="Caja Actual" >
                {hasViewHistorialPermiso && <Button variant="outlined" size="small" onClick={() => openModal("viewHistorialCajaActual")}>Historial de Arqueo</Button>}
                {hasOpenPermiso && <Button variant="contained" size="small" onClick={() => openModal("openCaja")}>Abrir Caja</Button>}
            </ListPage.Header.Actions>
        </ListPage.Header>
        <DataTable flex={1}>
            <DataTable.Content fit="flex" emptyText="La caja esta cerrada." />
        </DataTable>
    </ListPage>
}
